import { render } from "./ISS.vue?vue&type=template&id=8e07e6fa"
import script from "./ISS.vue?vue&type=script&lang=js"
export * from "./ISS.vue?vue&type=script&lang=js"

import "./ISS.vue?vue&type=style&index=0&id=8e07e6fa&lang=css"

import exportComponent from "F:\\Projetos-Lefisc\\front-end\\front_retfont\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__